// extracted by mini-css-extract-plugin
export default {"footer":"DrawerFooter_footer__WcJmU","material-status":"DrawerFooter_material-status__fTt4c"};